export default "__VITE_ASSET__DsJE5FzM__"